import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'antd';
import { LoadingOutlined, WarningOutlined } from '@ant-design/icons';
import { txt } from 'libs/i18n';
import LanguageSelect from 'components/LanguageSelect';
import { fetchTranscriptionProfiles, extractLanguagesFromProfiles } from 'api/user-api';
import { useSession } from 'components/Authenticated';
import styles from './style.module.less';
const ConfirmImportTrsxModal = ({ isVisible, title, content, okText, asyncAction, onCancel, language, }) => {
    const [loading, setLoading] = useState(false);
    const [availableLanguages, setAvailableLanguages] = useState([]);
    const { session } = useSession();
    const [form] = Form.useForm();
    useEffect(() => {
        if (loading) {
            // NOTE: React calls the function before the UI is rerendered. But importing trsx
            // can be computationally demanding and that is why it has to be called after
            // rerendering the UI to let the user now, that loading is occuring.
            setTimeout(() => {
                asyncAction(language !== null && language !== void 0 ? language : form.getFieldValue('language'));
                onCancel();
            }, 100);
        }
    }, [loading]);
    useEffect(() => {
        if (language === null) {
            const fetchLanguages = async () => {
                const result = await fetchTranscriptionProfiles(session.connection);
                if (result.isSuccess()) {
                    const profiles = result.get();
                    const languages = extractLanguagesFromProfiles(profiles);
                    setAvailableLanguages(languages);
                }
            };
            void fetchLanguages();
        }
    }, []);
    return (_jsxs(Modal, { className: styles.confirmationModal, title: (_jsxs(_Fragment, { children: [_jsx(WarningOutlined, { className: styles.iconWarning }), ' ', title] })), open: isVisible, onCancel: onCancel, footer: [
            _jsx(Button, { type: "default", onClick: onCancel, children: txt('cancel') }, "back"),
            _jsxs(Button, { type: "primary", danger: true, disabled: loading, onClick: () => setLoading(true), children: [loading ? _jsx(LoadingOutlined, {}) : null, okText] }, "submit"),
        ], children: [_jsx("p", { children: content }), language === null && (_jsxs(_Fragment, { children: [_jsx("p", { children: txt('missingLangInTrsx') }), _jsx(Form, { form: form, children: _jsx(Form.Item, { label: txt('langOfTranscription'), name: "language", rules: [{ required: true, message: txt('transcritpionLanguageRequired') }], children: _jsx(LanguageSelect, { locales: availableLanguages }) }) })] }))] }));
};
export default ConfirmImportTrsxModal;
